import { statusesSelectItems } from "@monorepo/administration/src/views/TkGeneration/constants/tkStatuses";

export const convertStatusToApi = (status: string): boolean | undefined => {
  return statusesSelectItems.find((item) => item.value === status)?.bool;
};
